// extracted by mini-css-extract-plugin
export default {"risk-level__container":"style_risk-level__container__tHX9w","risk-level__box-top":"style_risk-level__box-top__NWOz4","risk-level__box-gap":"style_risk-level__box-gap__VxUkE"};